<input
  type="file"
  (change)="fileChangeEvent($event)"
  id="image"
  style="display: none" />

<label
  for="image"
  class="label">
  Scegli un'immagine
</label>

<div class="mt-3">
  <div class="grid">
    <div class="col-6">
      <image-cropper
        [imageChangedEvent]="imageChangedEvent"
        format="png"
        [maintainAspectRatio]="false"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded($event)"
        (cropperReady)="cropperReady()"
        (loadImageFailed)="loadImageFailed()"></image-cropper>
    </div>
    <div class="col-6">
      <img
        class="w-full"
        [src]="croppedImage" />
    </div>
  </div>
</div>

<div class="modal-footer mt-2 flex justify-content-between">
  <p-button
    styleClass="butt red"
    [rounded]="true"
    (click)="close()"
    [outlined]="true"
    ><span>Annulla</span></p-button
  >
  <p-button
    styleClass="butt"
    [rounded]="true"
    (click)="save()"
    [outlined]="true"
    ><span>Salva</span></p-button
  >
</div>
